/**
 * Descriptions for wizard summary view.
 */
export const descriptions = {
  companyName: {description: 'Taloyhtiön nimi'},
  buildingType: {
    description: 'Rakennuksen tyyppi',
    block: {description: 'Kerrostalo'},
    terraced: {description: 'Rivitalo'},
    duplex: {description: 'Paritalo'},
    detached: {description: 'Erillistalo'}
  },
  buildingQuantity: {description: 'Rakennusten lukumäärä'},
  stairwellQuantity: {description: 'Rappukäytävien lukumäärä'},
  floorQuantity: {description: 'Kerrosten lukumäärä'},
  apartmentQuantity: {description: 'Asuntojen lukumäärä'},
  centralUnitPlacedInMiddle: {
    description: 'Keskusyksikön voi sijoittaa rakennusten väliin',
    yes: {description: 'Kyllä'},
    no: {description: 'Ei'}
  },
  waterMeterType: {
    description: 'Kohteessa mitataan',
    cold: {description: 'Kylmä vesi'},
    warm: {description: 'Lämmin vesi'},
    both: {description: 'Sekä kylmä että lämmin vesi'}
  },
  moreThanOneMeterPerApartment: {
    description: 'Enemmän kuin 1 mittarointia / huoneisto',
    yes: {description: 'Kyllä'},
    no: {description: 'Ei'}
  },
  meterSize: {description: 'Mittarikoko', dn15: {description: 'DN 15'}, dn20: {description: 'DN 20'}},
  apartmentScreensEnabled: {description: 'Huoneistonäytöillä', yes: {description: 'Kyllä'}, no: {description: 'Ei'}},
  systemType: {
    description: 'Langallinen / langaton järjestelmä',
    wired: {description: 'Langallinen'},
    wireless: {description: 'Langaton'}
  },
  temperatureMetersEnabled: {
    description: 'Lämpötilakosteusantureilla',
    yes: {description: 'Kyllä'},
    no: {description: 'Ei'}
  },
  wirelessMode: {
    description: 'Langaton tekniikka',
    hydrolinkAir: {description: 'Hydrolink Air'}
  },
  smokeDetectorType: {
    description: 'Palovaroittimet',
    none: {description: 'Ei'},
    mains: {description: 'HYDROLINK SD-LR 230V (kiinteä sähkönsyöttö)'},
    battery: {description: 'HYDROLINK SD-LR (paristotoiminen)'}
  }
}
